import { styled, Switch, type SwitchProps } from '@mui/material';

export const StyledSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 30,
  height: 16,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    color: theme.palette.grey[200],
    transitionDuration: '300ms',
    '&.Mui-checked': {
      color: theme.palette.common.white,
      transform: 'translateX(13px)',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.grey[200],
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 12,
    height: 12,
  },
  '& .MuiSwitch-track': {
    borderRadius: 13,
    backgroundColor: theme.palette.grey[500],
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));
